// extracted by mini-css-extract-plugin
module.exports = {"tipToutContainer":"styles_tipToutContainer__iHQtA","tipToutText":"styles_tipToutText__ZpqSr","tipToutLink":"styles_tipToutLink__d0tWT"};